import { FileItem } from "../../types/interfaces/filesStorage";

/** A Data Storage file the preview may rename, and what its dialog tells the person. */
export interface PreviewRename {
  staff: boolean;
  botsReadFolder: boolean;
}

export type PreviewSource =
  | { kind: "remote"; item: FileItem; rename?: PreviewRename }
  | {
      kind: "inline";
      name: string;
      size?: number;
      blob: Blob;
      backLabel?: string;
      onBack?: () => void;
    };

export interface PreviewOpenOptions {
  onBack?: () => void;
  backLabel?: string;
  rename?: PreviewRename;
}

/**
 * Stable identity of the previewed file, used both as the blob cache key and as
 * the key a table view is remembered under. Kept in one place so the two never
 * drift: an S3 object is identified by its key, and an inline blob (a file
 * unpacked from a ZIP, a secure upload) by name plus size, which is the most
 * the caller can tell us about it.
 */
export function previewSourceKey(source: PreviewSource): string {
  if (source.kind === "remote") return source.item.fsource;
  return `inline:${source.name}:${source.size ?? source.blob.size}`;
}
